/**
 * De vijf huurders. Waarden overgenomen uit `marken.ts` (mail, order K) —
 * de bron die de rechtspersoon al per firma voerde (review order K MINOR-3:
 * een Impressum-voet is een wettelijke aanduiding, geen designkeuze). Voor
 * `gu` geldt sinds masterbesluit 3 de volledige naam mét AG; de seed en de
 * productiekolom volgen in S-2 (migratie).
 *
 * `agentur` draagt een PLATZHALTER (O-1, owner-default bevestigd 07.09.2026):
 * rechtsvorm, naam, UID en adres van de agentuur zijn open; de volledige
 * levering is harde voorwaarde vóór P5.1 (docs/pricing-commerce/10 §6). De
 * RECHTSPERSOON van een offerte komt bovendien niet hiervandaan maar uit
 * `tenants.contractingOrganisationId` (D13) — dit register levert alleen
 * merk, korte naam en voet.
 */
// `as const satisfies` (hermeting-532 MINOR-1, huisvorm `schemas/bau.ts`/
// `schemas/pipeline.ts`): het ondiepe `Readonly<Record<…>>` liet
// `mandantFuer('gu')!.name = 'x'` schoon compileren — de «ene bron» was
// muteerbaar. Nu op twee niveaus bevroren: het TYPE (readonly-velden +
// as const) voor elke consument die typecheckt, en het OBJECT
// (`Object.freeze`, onderaan) zodat ook een `as`-omweg bij runtime een
// TypeError is — de tsconfig sluit testbestanden uit, dus een pin die
// alleen op tsc leunt zou nergens draaien (gemeten).
const TABEL = {
    finavest: {
        slug: 'finavest',
        konzern: 'finavest',
        name: 'Finavest AG',
        kurz: 'Finavest',
        fusszeile: 'Finavest AG · Zikadenweg 27a · 3006 Bern · UID CHE-256.652.167',
        impressumUrl: 'https://finavest.ch/impressum',
        datenschutzUrl: 'https://finavest.ch/datenschutz',
    },
    mlg: {
        slug: 'mlg',
        konzern: 'mlg',
        name: 'MLG Immobilien AG',
        kurz: 'MLG',
        fusszeile: 'MLG Immobilien AG · Zikadenweg 27A · 3006 Bern',
        impressumUrl: 'https://mlg-ag.ch/impressum/',
        datenschutzUrl: 'https://mlg-ag.ch/datenschutzerklaerung/',
    },
    gu: {
        slug: 'gu',
        konzern: 'mlg',
        name: 'MLG Generalunternehmung AG',
        kurz: 'MLG',
        fusszeile: 'MLG Generalunternehmung AG · Zikadenweg 27A · 3006 Bern',
        impressumUrl: 'https://mlg-ag.ch/impressum/',
        datenschutzUrl: 'https://mlg-ag.ch/datenschutzerklaerung/',
    },
    holding: {
        slug: 'holding',
        konzern: 'mlg',
        name: 'MLG Holding AG',
        kurz: 'MLG',
        fusszeile: 'MLG Holding AG · Zikadenweg 27A · 3006 Bern',
        impressumUrl: 'https://mlg-ag.ch/impressum/',
        datenschutzUrl: 'https://mlg-ag.ch/datenschutzerklaerung/',
    },
    agentur: {
        slug: 'agentur',
        konzern: 'mlg',
        name: 'MLG Marketing (Platzhalter)',
        kurz: 'MLG',
        fusszeile: 'MLG Marketing (Platzhalter) · Adresse und UID folgen mit O-1',
        impressumUrl: 'https://mlg-ag.ch/impressum/',
        datenschutzUrl: 'https://mlg-ag.ch/datenschutzerklaerung/',
    },
};
for (const m of Object.values(TABEL))
    Object.freeze(m);
export const MANDANTEN = Object.freeze(TABEL);
/**
 * Slug → identiteit; `null` voor alles wat we niet kennen. GEEN terugval hier:
 * mail kiest dan de exploitant, het portaal holding-neutraal — dat verschil is
 * een owner-besluit per oppervlak en hoort niet in dit register.
 */
export const mandantFuer = (slug) => slug && Object.hasOwn(MANDANTEN, slug) ? MANDANTEN[slug] : null;
/** Draagt deze huurder het MLG-concern (beeldmerk)? */
export const istMlgKonzern = (slug) => mandantFuer(slug)?.konzern === 'mlg';
